import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { NumericTextBox, NumericTextBoxChangeEvent  } from '@progress/kendo-react-inputs';
import { formatNumber } from '@progress/kendo-intl';
import { useCallback } from 'react';

const Rate = (props: GridCustomCellProps) => {
  const handleChange = (e: NumericTextBoxChangeEvent) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value || 0
      });
    }
  }

  const getFormat = useCallback(() => {
    switch(props.dataItem.RateUoM) {
      case 2:
        return 'N0';
      case 3:
        return 'p3';
      case 8:
        return 'C4';
      default:
        return 'N4';
    }
  }, [props.dataItem.RateUoM])

  const { dataItem } = props;
  const field = props.field || '';
  const dataValue = dataItem[field] === null ? '' : dataItem[field];
  const format = getFormat();

  return (
    <td {...props.tdProps}>
      {dataItem.inEdit ? <NumericTextBox
        value={dataValue}
        onChange={handleChange}
        format={format}
        spinners={false}
        step={0}
      /> : formatNumber(dataValue, format)}
    </td>
  );
}

export default Rate;
